/*
  Notch 7 (Oct 2026): pinned Add to Cart bar on phones/tablets.
  Appears only after the shopper scrolls past the main Add to Cart button, shows the
  selected variant (e.g. "Yam / M") so nobody adds the wrong size by accident, and
  mirrors the main button's state (Add to cart / Sold out / Unavailable).
*/
(function () {
  function init() {
    var bar = document.getElementById('n7-sticky-atc');
    if (!bar) return;
    document.body.appendChild(bar); // escape transformed ancestors so position:fixed works
    var btn = bar.querySelector('.n7-sticky__btn');
    var priceEl = bar.querySelector('.n7-sticky__price');
    var variantEl = bar.querySelector('.n7-sticky__variant');
    var hasVariants = bar.getAttribute('data-has-variants') === 'true';
    function main() { return document.querySelector('[id^="ProductSubmitButton-"]'); }
    function sync() {
      var m = main();
      if (!m) return;
      var span = m.querySelector('span');
      var label = (span ? span.textContent : m.textContent).trim();
      btn.textContent = label || 'Add to cart';
      btn.disabled = m.hasAttribute('disabled');
      var p = document.querySelector('[id^="price-"] .price--on-sale .price-item--sale') ||
              document.querySelector('[id^="price-"] .price__regular .price-item--regular');
      if (p) priceEl.textContent = p.textContent.trim();
      if (hasVariants) {
        var data = document.querySelector('variant-selects [data-selected-variant]');
        try {
          var v = data ? JSON.parse(data.textContent) : null;
          variantEl.textContent = v && v.title ? v.title : '';
        } catch (e) { variantEl.textContent = ''; }
      }
    }
    var visible = false;
    function check() {
      var m = main();
      if (!m) return;
      var show = m.getBoundingClientRect().bottom < 0;
      if (show !== visible) {
        visible = show;
        bar.classList.toggle('is-visible', show);
        document.body.classList.toggle('n7-sticky-on', show);
      }
    }
    btn.addEventListener('click', function () {
      var m = main();
      if (!m) return;
      if (m.hasAttribute('disabled')) {
        var vs = document.querySelector('variant-selects') || m;
        vs.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      m.click();
    });
    window.addEventListener('scroll', check, { passive: true });
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(sync, 80); })
      .observe(document.querySelector('product-info') || document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    sync();
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
